export var PACKAGE_SOURCE = "components";
export var PACKAGE_VERSION = "3.0.0 (03fe140e)";
export var GIT_SHA = "03fe140e";
export var THEME = "default";
export var SYSTEM = "core";
export var ALWAYS_VISUAL_REFRESH = false;
export var INCLUDE_ONE_THEME = true;